const USDC = ({ ...props }) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clip-path="url(#clip0)">
      <path
        d="M10.0167 20C15.5584 20 20.0167 15.5417 20.0167 10C20.0167 4.4583 15.5584 0 10.0167 0C4.47502 0 0.0167236 4.4583 0.0167236 10C0.0167236 15.5417 4.47502 20 10.0167 20Z"
        fill="#2775CA"
      />
      <path
        d="M12.7666 11.5833C12.7666 10.125 11.8916 9.62495 10.1416 9.41665C8.89165 9.24995 8.64165 8.91665 8.64165 8.33325C8.64165 7.74985 9.05835 7.37495 9.89165 7.37495C10.6416 7.37495 11.0583 7.62495 11.2666 8.24995C11.3083 8.37495 11.4334 8.45825 11.5584 8.45825H12.2249C12.3916 8.45825 12.5166 8.33325 12.5166 8.16665V8.12495C12.3499 7.20825 11.5999 6.49995 10.6416 6.41665V5.41665C10.6416 5.24995 10.5167 5.12495 10.3084 5.08325H9.68335C9.51665 5.08325 9.39165 5.20825 9.34995 5.41665V6.37495C8.09995 6.54165 7.30835 7.37495 7.30835 8.41665C7.30835 9.79165 8.14165 10.3333 9.89165 10.5417C11.0583 10.75 11.4334 11 11.4334 11.6667C11.4334 12.3334 10.8499 12.7917 10.0583 12.7917C8.97495 12.7917 8.59995 12.3333 8.47495 11.7083C8.43335 11.5417 8.30835 11.4583 8.18335 11.4583H7.47495C7.30835 11.4583 7.18335 11.5833 7.18335 11.75V11.7917C7.34995 12.8333 8.01665 13.5833 9.39165 13.7917V14.7917C9.39165 14.9583 9.51665 15.0833 9.72495 15.125H10.3499C10.5166 15.125 10.6417 15 10.6834 14.7917V13.7917C11.9334 13.5833 12.7666 12.7083 12.7666 11.5833V11.5833Z"
        fill="white"
      />
      <path
        d="M7.8918 15.9584C4.6418 14.7918 2.9751 11.1668 4.1835 7.95835C4.8085 6.20835 6.1835 4.87505 7.8918 4.25005C8.05851 4.16675 8.14181 4.04175 8.14181 3.83335V3.25005C8.14181 3.08335 8.05851 2.95835 7.8918 2.91675C7.8501 2.91675 7.76681 2.91675 7.72511 2.95835C3.7668 4.20835 1.6001 8.41675 2.8501 12.3751C3.6001 14.7084 5.3918 16.5001 7.72511 17.2501C7.89181 17.3334 8.05851 17.2501 8.10011 17.0834C8.14181 17.0418 8.14181 17.0001 8.14181 16.9168V16.3334C8.14181 16.2084 8.01681 16.0418 7.8918 15.9584ZM12.3085 2.95835C12.1418 2.87505 11.9751 2.95835 11.9335 3.12505C11.8918 3.16675 11.8918 3.20835 11.8918 3.29175V3.87505C11.8918 4.04175 12.0168 4.20835 12.1418 4.29175C15.3918 5.45835 17.0585 9.08335 15.8501 12.2918C15.2251 14.0418 13.8501 15.3751 12.1418 16.0001C11.9751 16.0834 11.8918 16.2084 11.8918 16.4168V17.0001C11.8918 17.1668 11.9751 17.2918 12.1418 17.3334C12.1835 17.3334 12.2668 17.3334 12.3085 17.2918C16.2668 16.0418 18.4335 11.8334 17.1835 7.87505C16.4335 5.50005 14.6001 3.70835 12.3085 2.95835V2.95835Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(0.0167236)"
        />
      </clipPath>
    </defs>
  </svg>
);
export default USDC;
